import React from "react";

import styles from "./HeaderBottom.module.scss";
import { Link } from "react-router";

const fittingsData = [
  { id: 0, text: "Карабины", link: "/catalog" },
  { id: 1, text: "Перья и Боа", link: "/catalog" },
  { id: 2, text: "Булавки", link: "/catalog" },
  { id: 3, text: "Декоры для одежды", link: "/catalog" },
  { id: 4, text: "Клеевые материалы", link: "/catalog" },
  { id: 5, text: "Кнопкни", link: "/catalog" },
  { id: 6, text: "Косая бейка", link: "/catalog" },
];
const textileData = [
  { id: 0, text: "Верхняя одежда", link: "/catalog" },
  { id: 1, text: "Детские", link: "/catalog" },
  { id: 2, text: "Для дома", link: "/catalog" },
  { id: 3, text: "Бельевые", link: "/catalog" },
  { id: 4, text: "Блузочные", link: "/catalog" },
  { id: 5, text: "Вечерние", link: "/catalog" },
];

const HeaderBottom: React.FC = () => {
  const [selectedMethod, setSelectedMethod] = React.useState({
    fittings: false,
    textile: true,
  });
  const [isOtherMenuActive, setIsOtherMenuActive] = React.useState(false);
  const menuRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const handleDocumentClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOtherMenuActive(false);
      }
    };

    if (isOtherMenuActive) {
      document.addEventListener("click", handleDocumentClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleDocumentClickOutside);
    };
  }, [isOtherMenuActive]);

  return (
    <div className={styles.bottom}>
      <div className={styles.switcher}>
        <button
          className={selectedMethod.textile ? `${styles.active}` : ""}
          onClick={() => setSelectedMethod({ fittings: false, textile: true })}
        >
          Ткани
        </button>
        <button
          className={selectedMethod.fittings ? `${styles.active}` : ""}
          onClick={() => setSelectedMethod({ fittings: true, textile: false })}
        >
          Фурнитура
        </button>
      </div>
      <ul className={styles.list} style={selectedMethod.textile ? { gap: 42 } : { gap: 15 }}>
        {selectedMethod.fittings &&
          fittingsData.map((item) => (
            <li key={item.id} className={`${styles.item} animated-underline`}>
              <Link to={item.link}>{item.text}</Link>
            </li>
          ))}
        {selectedMethod.textile &&
          textileData.map((item) => (
            <li key={item.id} className={`${styles.item} animated-underline`}>
              <Link to={item.link}>{item.text}</Link>
            </li>
          ))}
      </ul>
      <div className={styles.other}>
        <div ref={menuRef} className={styles.openMenu} onClick={() => setIsOtherMenuActive(!isOtherMenuActive)}>
          <p>и другие</p>
          <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 1L6.29545 4.67453C5.85795 5.10849 5.14205 5.10849 4.70455 4.67453L1 1"
              stroke="#1C1D20"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className={isOtherMenuActive ? `${styles.otherMenu} ${styles.active}` : styles.otherMenu}>
          <ul className={styles.otherList}>
            {selectedMethod.textile && (
              <>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">бельевые</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">блузочные</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">верхняя одежда</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">вечерние</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">детские</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">для дома</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">костюмные</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">плательныe</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">подкладочные</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">рубашечные</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">спортивные</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">сценические</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">эксклюзивные</Link>
                  </p>
                </li>
              </>
            )}
            {selectedMethod.fittings && (
              <>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Карабины</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Перья и Боа</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Булавки</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Декоры для одежды</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Клеевые материалы</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Кнопки</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Косая бейка</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Кружево</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Ленты</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Нитки</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Молнии</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Пряжки</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Пуговицы</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Фиксаторы</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Резинки</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Трикотажная фурнитура</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Швейные принадлежности</Link>
                  </p>
                </li>
                <li>
                  <p className="animated-underline">
                    <Link to="/catalog">Шнуры</Link>
                  </p>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeaderBottom;
